export default "__VITE_ASSET__KJogPd2w__"